import { Component, OnInit, OnDestroy, Input, ViewChild, Output, EventEmitter} from '@angular/core';

import { MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { Column } from '@ag-grid-community/all-modules';

export class GridColumn {
    colId: string;
    hideInColumns: boolean;
    headerName: string;
    visibility: boolean;
    pinned: boolean;
    width: number;
    newColumn: boolean;
}

@Component({
    selector: 'grid-columns',
    templateUrl: './pershing-grid-columns.component.html',
    providers: [ TranslatePipe ]
})
export class PershingGridColumnComponent implements OnInit, OnDestroy {

    agColumnList: Array<Column>;
    gridColumnList: Array<GridColumn>;
    maxLockColReached = false;

    @Input() set columnList(columns: Array<Column>) {
        this.agColumnList = columns;
        this.initializeColumnsMenu();
    }
    @Input() maxPinned: number;

    @Output() applyPreference: EventEmitter<Array<GridColumn>> = new EventEmitter<Array<GridColumn>>();

    @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

    constructor(private translatePipe: TranslatePipe) {}

    ngOnInit(): void {
        this.initializeColumnsMenu();
    }

    ngOnDestroy(): void {}

    toggleColumnDisplay(column: GridColumn) {
        column.visibility = !column.visibility;
    }

    toggleColumnLock(column: GridColumn) {
        const currentNumberOfPinnedCols = this.getCurrentNumberOfPinnedCols();
        if (currentNumberOfPinnedCols < this.maxPinned) {
            column.pinned = !column.pinned;
            if (column.pinned) {
                column.visibility = true;
                if ((currentNumberOfPinnedCols + 1) === this.maxPinned) {
                    this.maxLockColReached = true;
                }
            }
        } else if (currentNumberOfPinnedCols === this.maxPinned) {
            if (column.pinned) {
                column.pinned = !column.pinned;
                this.maxLockColReached = false;
            }
        } else {
            if (column.pinned) {
                column.pinned = !column.pinned;
                if ((currentNumberOfPinnedCols - 1) >= this.maxPinned) {
                    this.maxLockColReached = true;
                }
            }
        }
    }

    closeColumnsMenu(): void {
        this.menuTrigger.closeMenu();
    }

    columnsMenuClosed(): void {
        this.initializeColumnsMenu();
    }

    saveColumnSettings() {
        this.sortGridColumns();
        this.applyPreference.emit(this.gridColumnList);
        this.closeColumnsMenu();
    }

    private initializeColumnsMenu(): void {
        if (this.agColumnList && this.agColumnList.length > 0 ) {
            this.gridColumnList = this.agColumnList.map( (col) =>  {
                const columnDef = col.getColDef();
                const gridColumn = new GridColumn();
                gridColumn.colId = col.getColId();
                gridColumn.headerName = columnDef.headerName;
                gridColumn.visibility = col.isVisible();
                gridColumn.pinned = gridColumn.visibility ? col.isPinned() : false;
                gridColumn.hideInColumns = columnDef['hideInColumns'];
                gridColumn.width = columnDef.width;
                if (columnDef.type) {
                    if (typeof columnDef.type === 'string' || columnDef.type instanceof Array) {
                         gridColumn.newColumn = columnDef.type.indexOf('NEW_COLUMN') > -1 ? true : false;
                    }
                }
                return gridColumn;
            });
        } else {
            this.gridColumnList = [];
        }

        this.sortGridColumns();
        const currentNumberOfPinnedCols = this.getCurrentNumberOfPinnedCols();
        if (currentNumberOfPinnedCols >= this.maxPinned) {
            this.maxLockColReached = true;
        } else {
            this.maxLockColReached = false;
        }
    }

    private getCurrentNumberOfPinnedCols(): number {
        let numberOfPinnedCols = 0;
        this.gridColumnList.forEach( (column) => {
            if ((column.headerName !== '' && !column.hideInColumns) && column.pinned) {
                numberOfPinnedCols++;
            }
        });
        return numberOfPinnedCols;
    }

    private sortGridColumns() {
        this.gridColumnList.sort( (col1, col2) => {
            let sortValue: number;
            if (col1.hideInColumns === true || col1.headerName === '' ||
                col2.hideInColumns === true || col2.headerName === '') {
                sortValue = 0;
            } else {
                sortValue = (col1.pinned === col2.pinned) ? 0 : col1.pinned ? -1 : 1;
                if (sortValue === 0 ) {
                    sortValue = (col1.visibility === col2.visibility) ? 0 : col1.visibility ? -1 : 1;
                }
            }
            return sortValue;
        });
    }

    formatHeader(key: string): string {
        let headerName: string = this.translatePipe.transform(key);
        headerName = headerName.replace(/<\w+?\>\w*?<\/\w+?\>/, '');
        return headerName;
    }
}
